var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Particles',{attrs:{"id":"tsparticles","particlesInit":_vm.particlesInit,"particlesLoaded":_vm.particlesLoaded,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }